import { ProductListWithFilter } from './ProductListWithFilter';
import { useRouter } from 'next/router';
import { HeadSection } from 'components/HeadSection';
import {
  BreadcrumbProps,
  Breadcrumbs,
  Container,
  styled,
} from '@teko/ds-desktop';
import { t } from 'i18n';
import { useTenantConfig } from 'hooks';
import { Description } from '@teko/teko-ecommerce';
import { Breadcrumb, SeoInfo } from '../shared';
import { SearchProductFilter } from '@teko/discovery/v2';
import { ProductCardProps } from '@teko/types/ecommerce';
import Head from 'next/head';

export interface SearchPageProps {
  serverProducts?: ProductCardProps[];
  serverPagination?: {
    totalItems: number;
    totalPages: number;
  };
  seoInfo?: SeoInfo;
  serverFilters?: SearchProductFilter;
  filterPrice?: {
    max: number;
    min: number;
  };
  breadcrumbs?: Breadcrumb;
  forceNoIndex?: boolean;
}

export const SearchPage: NextPage<SearchPageProps> = (props) => {
  const {
    breadcrumbs,
    seoInfo,
    forceNoIndex,
    serverProducts,
    serverFilters,
    filterPrice,
    serverPagination,
  } = props;
  const router = useRouter();
  const { query, asPath } = router;
  const { page } = query;
  const { epicOmni976, addSchemaBreadcrumbList, baseDomain } =
    useTenantConfig();

  // display breadcrumbs for collection page
  const breadCrumbs: BreadcrumbProps[] | null = epicOmni976
    ? breadcrumbs && breadcrumbs.length
      ? [
          {
            link: '/',
            name: t('Trang chủ'),
          },
          ...breadcrumbs,
          {
            disabled: true,
            link: '#',
            name: seoInfo?.siteTitle,
            isEndOfBread: true,
          },
        ]
      : null
    : seoInfo?.siteTitle
    ? [
        {
          link: '/',
          name: t('Trang chủ'),
        },
        {
          disabled: true,
          link: '#',
          name: seoInfo?.siteTitle,
          isEndOfBread: true,
        },
      ]
    : null;
  return (
    <>
      {!!addSchemaBreadcrumbList && !!breadCrumbs?.length && (
        <Head>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'BreadcrumbList',
                itemListElement: breadCrumbs.map(({ name, link }, index) => ({
                  '@type': 'ListItem',
                  position: index + 1,
                  item: {
                    name:
                      typeof name === 'string'
                        ? name
                        : !index && t('Trang chủ'),
                    '@id':
                      index === breadCrumbs.length - 1 || link === '#'
                        ? `${baseDomain}${asPath?.split('?')[0]}`
                        : `${baseDomain}${link}`,
                  },
                })),
              }),
            }}
          />
        </Head>
      )}
      <HeadSection
        {...seoInfo}
        noindex={forceNoIndex || !seoInfo?.canonical}
        title={seoInfo?.metaTitle || seoInfo?.siteTitle}
        links={[
          seoInfo?.siteDescription
            ? {
                rel: 'stylesheet',
                href: 'https://shopfront-cdn.tekoapis.com/static/stylesheet/ckeditor.css',
              }
            : {},
        ]}
      />
      {breadCrumbs && (
        <Container>
          <Breadcrumbs breadcrumbs={breadCrumbs} paddingLeft="s16" />
        </Container>
      )}

      <ProductListWithFilter
        marginTop={breadCrumbs ? undefined : 's16'}
        serverProducts={serverProducts}
        serverPagination={serverPagination}
        serverFilters={serverFilters}
        filterPrice={filterPrice}
        siteTitle={seoInfo?.siteTitle}
        seoInfo={seoInfo}
      />
      {seoInfo?.siteDescription && !page && (
        <Container>
          <StyledDescription
            className="ck-content"
            content={seoInfo?.siteDescription}
            maxHeight={760}
            showMoreLabel={t('Xem thêm nội dung')}
            showLessLabel={t('Thu gọn nội dung')}
          />
        </Container>
      )}
    </>
  );
};

const StyledDescription = styled(Description)`
  background-color: white;
  margin-bottom: 1rem;
  border-radius: 1rem;
`;
